import {
    SHOW_HUD,
    HIDE_HUD
} from "../store/types";

export const showHUD = (msg, severity = 'error') => (dispatch) => {
    dispatch({
        type: SHOW_HUD,
        payload: { msg, severity }
    });
};

export const hideHUD = () => (dispatch) => {
    dispatch({
        type: HIDE_HUD
    });
};
